import { IFormController } from 'angular';

// Show error messages for all invalid fields
export function dirtyfields(form: IFormController): void {
    for (const field in form) {
        // look at each form input with a name attribute set
        // checking if it is pristine and not a '$' special field
        if (field[0] !== '$' && form[field].$pristine) {
            form[field].$setDirty();
            form[field].$setTouched();
        }
    }
}